export const imageScaler = (maxWidth: number, width: number, height: number) => {
  const percentSmaller = maxWidth / width;
  const scaledDownHeight = Math.trunc(height * percentSmaller);
  return scaledDownHeight;
};
